import React from 'react'
import PropTypes from 'prop-types'
import { Box, styled } from '@mui/material'
import { ReactComponent as RoundCloseSvgIcon } from './Resources/round-close-button.svg'
import { FilterChip } from 'packages/eid-ui'

const FilterBarRoot = styled(Box)(({ theme }) => ({
    backgroundColor: '#ffffff',
    maxWidth: '48.5rem',
    borderRadius: '0.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '0.5rem 0 0.5rem 1rem',
}))

const FilterItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: ' #e9f4fb',
    borderRadius: '1rem',
    minWidth: '8rem',
    maxHeight: '2rem',
    color: '#0057A0',
    // marginLeft: '10px',
    margin: '0.5rem 1.5rem 0.5rem 0',
    padding: '0 1rem',
}))

const FilterIcon = styled(Box)(({ theme }) => ({
    marginLeft: '1rem',
}))

const FilterBar = ({ list, fontSize }) => {
    return (
        <FilterBarRoot>
            {list.map((item, index) => (
                <FilterChip
                    //bgColor=""
                    label={item.label}
                    fontSize={fontSize}
                    key={index}
                    height="1.4rem"
                    //border="solid 1px #453fbb"
                    CloseIcon={RoundCloseSvgIcon}
                    borderRadius="1rem"
                    onClick={() => {}}
                />
            ))}
        </FilterBarRoot>
    )
}

FilterBar.propTypes = {
    list: PropTypes.array.isRequired,
    fontSize: PropTypes.string,
    // fontColor: PropTypes.string,
}

FilterBar.defaultProps = {}

export default FilterBar
